// DS: i7.5
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorAlignCenter = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M16 5a1 1 0 110 2H8a1 1 0 010-2h8zm1 13a1 1 0 01-1 1H8a1 1 0 110-2h8a1 1 0 011 1zm3-6a1 1 0 01-1 1H5a1 1 0 110-2h14a1 1 0 011 1z",
        clipRule: "evenodd"
    })));
};
EditorAlignCenter.displayName = 'EditorAlignCenter';
export default EditorAlignCenter;

//# sourceMappingURL=EditorCenter.js.map